export const COMPLETED_STEPS_STORAGE_KEY = 'completedSteps'
export const USER_STORAGE_KEY = 'user'
export const SESSION_STORAGE_KEY = 'session'
